export default __webpack_public_path__ + "static/media/banner-course-detail-id.cac6a935.png";